import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios';
import {api_base_url, base_url} from '../common/Constants';
 
class Slider extends React.Component{

    constructor(props){
        super(props);
       
        this.state = { 
            loading:0
        }
 
    }
     
    componentDidMount()
    {   
        if(this.props.content && this.state.loading === 1)
            {
                 this.setState({loading:0});     
            }
    }
     
     
    render()
    { 
         
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
        
    return (

        <div class="banner-area inc-top-heading">
        <div id="bootcarousel" class="carousel slide carousel-fade animate_text" data-ride="carousel">
            
            <div class="carousel-inner text-light carousel-zoom">

            {this.props.banners.map((item,key)=>(

                <div class={key == 0 ? "item active" : "item"}>
                <div class="slider-thumb bg-cover" style={{backgroundImage: `url(${item.image})`}}></div>
                <div class="box-table shadow dark ">
                    <div class="box-cell">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="content">
                                        <h3 data-animation="animated slideInRight">{item.title} </h3>
                                        <h1 data-animation="animated slideInLeft"><div dangerouslySetInnerHTML={{ __html: item.subtitle }} /> </h1>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div> 

            ))};
           
             
             
               
            </div>
             

          
            <Link class="left carousel-control shadow fixed" to="#bootcarousel" data-slide="prev">
                <i class="fa fa-angle-left"></i>
                <span class="sr-only">Previous</span>
            </Link>
            <Link class="right carousel-control shadow fixed" to="#bootcarousel" data-slide="next">
                <i class="fa fa-angle-right"></i>
                <span class="sr-only">Next</span>
            </Link>
        </div>
    </div>
 
    );
}
}
 

export default Slider;